var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "expedient-invoices" },
    [
      !_vm.showAddInvoice && _vm.gridColumns
        ? _c("GridTableComponent", {
            ref: "grid",
            attrs: {
              itemsData: _vm.listItems,
              gridConfiguration: _vm.gridColumns,
              title: _vm.title,
              toolbarOptions: _vm.customToolbarOptions,
              contextMenuItems: _vm.gridContextMenuItems,
              listName: _vm.listName,
              context: _vm.invoiceContext,
              showHeader: false,
              disabledContextMenuBeforeOpen: false,
              customToolbarContextMenuItems: _vm.invoicesContextMenuItems,
              commandClick: _vm.onCommandClick,
            },
            on: {
              cellClicked: _vm.onCellClicked,
              contextMenuBeforeOpen: _vm.onContextMenuBeforeOpen,
              contextMenuClicked: _vm.onContextMenuClicked,
              toolbarClicked: _vm.onToolbarClicked,
              customToolbarContextMenuClick: _vm.onInvoiceAddClick,
            },
          })
        : _vm._e(),
      _c("TemplateSelectorComponent", {
        attrs: {
          showDialog: _vm.showTemplateDialog,
          idEntityType: _vm.idEntityType,
        },
        on: {
          closeTemplateDialog: _vm.closeTemplateDialog,
          generateTemplateDialog: _vm.generateTemplateDialog,
        },
      }),
      _vm.getShowFacturaEDialog
        ? _c("FacturaEDialog", {
            key: _vm.getFacturaEDialogKey,
            attrs: {
              showDialog: _vm.showFacturaEDialog,
              invoiceId: _vm.getSelectedInvoiceId,
              invoiceDescription: _vm.getSelectedInvoiceDescription,
              invoiceTemplates: _vm.hasProfessionalFacturaETemplate,
            },
            on: { closeDialog: _vm.closeFacturaEDialog },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }